import { sortBoardTaskIds } from 'entities/task';

import { useAppSelector } from '../../../../../../../store';
import { TasksBlockType } from '../../../../../model/taskBoard';

export const useTaskCardList = (type: TasksBlockType) => {
    const { tabs, filteredTabs } = useAppSelector((state) => state.tasksInformationReducer);
    const taskEntities = useAppSelector((state) => state.tasksReducer.entities);

    const boardTasks = tabs?.board[type];
    const taskIds = filteredTabs ? filteredTabs.board[type] : boardTasks;
    const tasks = taskIds ? sortBoardTaskIds(type, taskIds, taskEntities) : taskIds;

    return { tasks, filteredTabs };
};
